import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  user = null
  message = null;
  class = null;
  message1 = null;
  class1 = null;
  action = null;
  submitted = false;
  public Form: FormGroup;
  public changePasswordForm: FormGroup;

  ngOnInit() {
    this.Form = this.formBuilder.group({
      name: ['', Validators.required],
      contact: ['', Validators.required],
      email: ['', Validators.required],
      role: ['', Validators.required],
      _id: ['']
    });

    this.changePasswordForm = this.formBuilder.group({
      old: ['', Validators.required],
      new: ['', Validators.required],
      confirm: ['', Validators.required],
      _id: ['']
    });

    
    
    var user  = localStorage.getItem('userId');

    this.http.get<any>(`${environment.apiUrl}/adminById/` + user, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      data => {
        (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
        this.user = data.data;
        this.Form.patchValue({
          _id: data.data._id,
          name: data.data.name,
          contact: data.data.contact,
          email: data.data.email,
          role: data.data.role,
        });

    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });

    this.changePasswordForm.patchValue({
      _id: user,
    });

   }

   get f() { return this.Form.controls; }

   onFormSubmit() {

    if (this.Form.invalid) {
      return;
    }

    this.http.put<any>(`${environment.apiUrl}/admin`, this.Form.value, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      res => {
        (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
        // console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return 0;
        }else{
          this.message = 'Successfully Updated';
          this.class = 'btn btn-success';
          this.ngOnInit();
        } 
        
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
   }

   get f1() { return this.changePasswordForm.controls; }

   onFormSubmit1() {

    if (this.changePasswordForm.invalid) {
      return;
    }

    if(this.changePasswordForm.value.new != this.changePasswordForm.value.confirm){
      this.message1 = 'New Password Does Not Match!';
      this.class1 = 'btn-primary';
      return 0;
    }

    this.http.post<any>(`${environment.apiUrl}/changepassword/`, this.changePasswordForm.value, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      res => {
        (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
        if(res.status == '500'){
          this.message1 = res.message;
          this.class1 = 'btn-primary';
          return 0;
        }else{
          this.message1 = 'Password Successfully Changed';
          this.class1 = 'btn-success';
          this.ngOnInit();
        } 
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
   }

}
